export enum Types {
  //? auth...
  LOGIN = 'LOGIN',
  LOGOUT = 'LOGOUT',
  REFRESH = 'REFRESH',
  INFO = 'INFO',
  //* loading...
  S_LOADING = 'S_LOADING',
  E_LOADING = 'E_LOADING',
  START_INFO_LOADING = 'START_INFO_LOADING',
  END_INFO_LOADING = 'END_INFO_LOADING',

  //? subdistricts...
  FETCH_SUBDISTRICTS = 'FETCH_SUBDISTRICTS',

  //* loading...
  START_SUBDISTRICTS = 'START_SUBDISTRICTS',
  END_SUBDISTRICTS = 'END_SUBDISTRICTS',

  //* errors...
  ERROR_SUBDISTRICT = 'ERROR_SUBDISTRICT',
  RESET_SUBDISTRICT = 'RESET_SUBDISTRICT',

  //? citiesV2...
  FETCH_CITIES_V2 = 'FETCH_CITIES_V2',
  CREATE_CITY_V2 = 'CREATE_CITY_V2',
  UPDATE_CITY_V2 = 'UPDATE_CITY_V2',

  //* loading...
  START_CITIES_V2 = 'START_CITIES_V2',
  END_CITIES_V2 = 'END_CITIES_V2',
  START_CITY_V2 = 'START_CITY_V2',
  END_CITY_V2 = 'END_CITY_V2',

  //* errors...
  ERROR_CITIES_V2 = 'ERROR_CITIES_V2',
  RESET_CITIES_V2 = 'RESET_CITIES_V2',

  //? home...
  FETCH_HOME = 'FETCH_HOME',

  //? users...
  SEARCH_CUSTOMERS = 'SEARCH_CUSTOMERS',
  FETCH_CUSTOMERS = 'FETCH_CUSTOMERS',
  FETCH_CUSTOMER = 'FETCH_CUSTOMER',
  FETCH_CUSTOMER_ORDERS = 'FETCH_CUSTOMER_ORDERS',
  CREATE_CUSTOMER = 'CREATE_CUSTOMER',
  UPDATE_CUSTOMER = 'UPDATE_CUSTOMER',
  UPDATE_WALLET = 'UPDATE_WALLET',
  STATE_CUSTOMER = 'STATE_CUSTOMER',
  DELETE_CUSTOMER = 'DELETE_CUSTOMER',
  NUMBERS_CUSTOMERS = 'NUMBERS_CUSTOMERS',
  //* search...
  FETCH_CUSTOMERS_SEARCH = 'FETCH_CUSTOMERS_SEARCH',
  //* loading...
  START_CUSTOMERS = 'START_CUSTOMERS',
  END_CUSTOMERS = 'END_CUSTOMERS',
  START_CUSTOMER = 'START_CUSTOMER',
  END_CUSTOMER = 'END_CUSTOMER',
  START_WALLET = 'START_WALLET',
  END_WALLET = 'END_WALLET',
  //* errors...
  ERROR_CUSTOMER = 'ERROR_CUSTOMER',
  RESET_CUSTOMER = 'RESET_CUSTOMER',

  START_DELETE = 'START_DELETE',
  END_DELETE = 'END_DELETE',

  //? admins...
  FETCH_ADMINS = 'FETCH_ADMINS',
  FETCH_ADMIN = 'FETCH_ADMIN',
  CREATE_ADMIN = 'CREATE_ADMIN',
  UPDATE_ADMIN = 'UPDATE_ADMIN',
  WALLET_ADMIN = 'WALLET_ADMIN',
  STATE_ADMIN = 'STATE_ADMIN',
  DELETE_ADMIN = 'DELETE_ADMIN',
  //* loading...
  START_ADMINS = 'START_ADMINS',
  END_ADMINS = 'END_ADMINS',
  START_ADMIN = 'START_ADMIN',
  END_ADMIN = 'END_ADMIN',
  START_WALLET_ADMIN = 'START_WALLET_ADMIN',
  END_WALLET_ADMIN = 'END_WALLET_ADMIN',
  //* errors...
  ERROR_ADMIN = 'ERROR_ADMIN',
  RESET_ADMIN = 'RESET_ADMIN',

  //? drivers...
  FETCH_DRIVERS = 'FETCH_DRIVERS',
  FETCH_DRIVER = 'FETCH_DRIVER',
  CREATE_DRIVER = 'CREATE_DRIVER',
  UPDATE_DRIVER = 'UPDATE_DRIVER',
  WALLET_DRIVER = 'WALLET_DRIVER',
  STATE_DRIVER = 'STATE_DRIVER',
  DELETE_DRIVER = 'DELETE_DRIVER',
  //* loading...
  START_DRIVERS = 'START_DRIVERS',
  END_DRIVERS = 'END_DRIVERS',
  START_DRIVER = 'START_DRIVER',
  END_DRIVER = 'END_DRIVER',
  START_WALLET_DRIVER = 'START_WALLET_DRIVER',
  END_WALLET_DRIVER = 'END_WALLET_DRIVER',
  //* errors...
  ERROR_DRIVER = 'ERROR_DRIVER',
  RESET_DRIVER = 'RESET_DRIVER',

  //? teams...
  FETCH_TEAMS = 'FETCH_TEAMS',
  FETCH_TEAM = 'FETCH_TEAM',
  CREATE_TEAM = 'CREATE_TEAM',
  UPDATE_TEAM = 'UPDATE_TEAM',
  STATE_TEAM = 'STATE_TEAM',
  DELETE_TEAM = 'DELETE_TEAM',
  //* loading...
  START_TEAMS = 'START_TEAMS',
  END_TEAMS = 'END_TEAMS',
  START_TEAM = 'START_TEAM',
  END_TEAM = 'END_TEAM',
  //* errors...
  ERROR_TEAM = 'ERROR_TEAM',
  RESET_TEAM = 'RESET_TEAM',

  //? advertisements...
  SEARCH_ADVERTISEMENTS = 'SEARCH_ADVERTISEMENTS',
  FETCH_ADVERTISEMENTS = 'FETCH_ADVERTISEMENTS',
  FETCH_ADVERTISEMENT = 'FETCH_ADVERTISEMENT',
  CREATE_ADVERTISEMENT = 'CREATE_ADVERTISEMENT',
  UPDATE_ADVERTISEMENT = 'UPDATE_ADVERTISEMENT',
  STATE_ADVERTISEMENT = 'STATE_ADVERTISEMENT',
  POSITION_ADVERTISEMENT = 'POSITION_ADVERTISEMENT',
  DELETE_ADVERTISEMENT = 'DELETE_ADVERTISEMENT',
  //* loading...
  START_ADVERTISEMENTS = 'START_ADVERTISEMENTS',
  END_ADVERTISEMENTS = 'END_ADVERTISEMENTS',
  START_ADVERTISEMENT = 'START_ADVERTISEMENT',
  END_ADVERTISEMENT = 'END_ADVERTISEMENT',
  //* errors...
  ERROR_ADVERTISEMENT = 'ERROR_ADVERTISEMENT',
  RESET_ADVERTISEMENT = 'RESET_ADVERTISEMENT',

  //? order-histories...
  SEARCH_ORDER_HISTORIES = 'SEARCH_ORDER_HISTORIES',
  FETCH_ORDER_HISTORIES = 'FETCH_ORDER_HISTORIES',
  FETCH_ORDER_HISTORY = 'FETCH_ORDER_HISTORY',
  CREATE_ORDER_HISTORY = 'CREATE_ORDER_HISTORY',
  UPDATE_ORDER_HISTORY = 'UPDATE_ORDER_HISTORY',
  STATE_ORDER_HISTORY = 'STATE_ORDER_HISTORY',
  POSITION_ORDER_HISTORY = 'POSITION_ORDER_HISTORY',
  DELETE_ORDER_HISTORY = 'DELETE_ORDER_HISTORY',
  //* loading...
  START_ORDER_HISTORIES = 'START_ORDER_HISTORIES',
  END_ORDER_HISTORIES = 'END_ORDER_HISTORIES',
  START_ORDER_HISTORY = 'START_ORDER_HISTORY',
  END_ORDER_HISTORY = 'END_ORDER_HISTORY',
  //* errors...
  ERROR_ORDER_HISTORY = 'ERROR_ORDER_HISTORY',
  RESET_ORDER_HISTORY = 'RESET_ORDER_HISTORY',

  //? order-activities... one feed, shared by both order forks
  FETCH_ORDER_ACTIVITIES = 'FETCH_ORDER_ACTIVITIES',
  //* loading...
  START_ORDER_ACTIVITIES = 'START_ORDER_ACTIVITIES',
  END_ORDER_ACTIVITIES = 'END_ORDER_ACTIVITIES',
  //* errors...
  ERROR_ORDER_ACTIVITIES = 'ERROR_ORDER_ACTIVITIES',
  RESET_ORDER_ACTIVITIES = 'RESET_ORDER_ACTIVITIES',

  //? Main sections...
  SEARCH_MAIN_SECTIONS = 'SEARCH_MAIN_SECTIONS',
  FETCH_MAIN_SECTIONS = 'FETCH_MAIN_SECTIONS',
  FETCH_MAIN_SECTION = 'FETCH_MAIN_SECTION',
  CREATE_MAIN_SECTION = 'CREATE_MAIN_SECTION',
  UPDATE_MAIN_SECTION = 'UPDATE_MAIN_SECTION',
  STATE_MAIN_SECTION = 'STATE_MAIN_SECTION',
  POSITION_MAIN_SECTION = 'POSITION_MAIN_SECTION',
  DELETE_MAIN_SECTION = 'DELETE_MAIN_SECTION',
  //* loading...
  START_MAIN_SECTIONS = 'START_MAIN_SECTIONS',
  END_MAIN_SECTIONS = 'END_MAIN_SECTIONS',
  START_MAIN_SECTION = 'START_MAIN_SECTION',
  END_MAIN_SECTION = 'END_MAIN_SECTION',
  //* errors...
  ERROR_MAIN_SECTION = 'ERROR_MAIN_SECTION',
  RESET_MAIN_SECTION = 'RESET_MAIN_SECTION',

  // //? products...
  SEARCH_PRODUCTS = 'SEARCH_PRODUCTS',
  FETCH_PRODUCTS = 'FETCH_PRODUCTS',
  FETCH_PRODUCT = 'FETCH_PRODUCT',
  CREATE_PRODUCT = 'CREATE_PRODUCT',
  UPDATE_PRODUCT = 'UPDATE_PRODUCT',
  STATE_PRODUCT = 'STATE_PRODUCT',
  POSITION_PRODUCT = 'POSITION_PRODUCT',
  DELETE_PRODUCT = 'DELETE_PRODUCT',
  //* loading...
  START_PRODUCTS = 'START_PRODUCTS',
  END_PRODUCTS = 'END_PRODUCTS',
  START_PRODUCT = 'START_PRODUCT',
  END_PRODUCT = 'END_PRODUCT',
  START_PRODUCT_UPDATE = 'START_PRODUCT_UPDATE',
  END_PRODUCT_UPDATE = 'END_PRODUCT_UPDATE',
  //* Ref orders...
  SEARCH_ORDER_PRODUCTS = 'SEARCH_ORDER_PRODUCTS',
  FETCH_ORDER_PRODUCTS = 'FETCH_ORDER_PRODUCTS',
  FETCH_ORDER_SELECTED_PRODUCTS = 'FETCH_ORDER_SELECTED_PRODUCTS',
  //* errors...
  ERROR_PRODUCT = 'ERROR_PRODUCT',
  RESET_PRODUCT = 'RESET_PRODUCT',
  CLEAR_PRODUCT = 'CLEAR_PRODUCT',

  // //? outfits...
  SEARCH_OUTFITS = 'SEARCH_OUTFITS',
  FETCH_OUTFITS = 'FETCH_OUTFITS',
  FETCH_OUTFIT = 'FETCH_OUTFIT',
  CREATE_OUTFIT = 'CREATE_OUTFIT',
  UPDATE_OUTFIT = 'UPDATE_OUTFIT',
  STATE_OUTFIT = 'STATE_OUTFIT',
  POSITION_OUTFIT = 'POSITION_OUTFIT',
  DELETE_OUTFIT = 'DELETE_OUTFIT',
  //* loading...
  START_OUTFITS = 'START_OUTFITS',
  END_OUTFITS = 'END_OUTFITS',
  START_OUTFIT = 'START_OUTFIT',
  END_OUTFIT = 'END_OUTFIT',
  START_OUTFIT_UPDATE = 'START_OUTFIT_UPDATE',
  END_OUTFIT_UPDATE = 'END_OUTFIT_UPDATE',
  START_OUTFIT_DELETE = 'START_OUTFIT_DELETE',
  END_OUTFIT_DELETE = 'END_OUTFIT_DELETE',
  //* Ref orders...
  SEARCH_ORDER_OUTFITS = 'SEARCH_ORDER_OUTFITS',
  FETCH_ORDER_OUTFITS = 'FETCH_ORDER_OUTFITS',
  FETCH_ORDER_SELECTED_OUTFITS = 'FETCH_ORDER_SELECTED_OUTFITS',
  //* errors...
  ERROR_OUTFIT = 'ERROR_OUTFIT',
  RESET_OUTFIT = 'RESET_OUTFIT',

  //? orders...
  SEARCH_ORDERS = 'SEARCH_ORDERS',
  FETCH_ORDERS = 'FETCH_ORDERS',
  FETCH_DRIVER_ORDERS = 'FETCH_DRIVER_ORDERS',
  FETCH_ORDER_STATUS = 'FETCH_ORDER_STATUS',
  FETCH_ORDER_BRANDS_NOT_SHIPPED = 'FETCH_ORDER_BRANDS_NOT_SHIPPED',
  FETCH_PRINT_ORDERS = 'FETCH_PRINT_ORDERS',
  FETCH_ORDER = 'FETCH_ORDER',
  CREATE_ORDER = 'CREATE_ORDER',
  UPDATE_ORDER = 'UPDATE_ORDER',
  STATE_ORDER = 'STATE_ORDER',
  STATE_ORDERS = 'STATE_ORDERS',
  DELETE_ORDER = 'DELETE_ORDER',
  //* loading...
  START_ORDERS = 'START_ORDERS',
  END_ORDERS = 'END_ORDERS',
  START_ORDER = 'START_ORDER',
  END_ORDER = 'END_ORDER',
  START_ORDER_STATUS = 'START_ORDER_STATUS',
  END_ORDER_STATUS = 'END_ORDER_STATUS',
  START_REORDER_ORDER_STATUS = 'START_REORDER_ORDER_STATUS',
  END_REORDER_ORDER_STATUS = 'END_REORDER_ORDER_STATUS',
  START_ORDER_BRANDS_NOT_SHIPPED = 'START_ORDER_BRANDS_NOT_SHIPPED',
  END_ORDER_BRANDS_NOT_SHIPPED = 'END_ORDER_BRANDS_NOT_SHIPPED',
  START_PRINT_ORDERS = 'START_PRINT_ORDERS',
  END_PRINT_ORDERS = 'END_PRINT_ORDERS',
  ORDERS = 'ORDERS',
  START_CUSTOMER_ORDERS = 'START_CUSTOMER_ORDERS',
  END_CUSTOMER_ORDERS = 'END_CUSTOMER_ORDERS',
  START_DRIVER_ORDERS = 'START_DRIVER_ORDERS',
  END_DRIVER_ORDERS = 'END_DRIVER_ORDERS',
  //* errors...
  ERROR_ORDER = 'ERROR_ORDER',
  RESET_ORDER = 'RESET_ORDER',

  //? purchased history notes...
  PH_FETCH_ORDER_NOTES = 'PH_FETCH_ORDER_NOTES',
  PH_FETCH_ORDER_NOTE = 'PH_FETCH_ORDER_NOTE',
  PH_CREATE_ORDER_NOTE = 'PH_CREATE_ORDER_NOTE',
  PH_UPDATE_ORDER_NOTE = 'PH_UPDATE_ORDER_NOTE',
  PH_STATE_ORDER_NOTE = 'PH_STATE_ORDER_NOTE',
  PH_DELETE_ORDER_NOTE = 'PH_DELETE_ORDER_NOTE',
  PH_START_ORDER_NOTES = 'PH_START_ORDER_NOTES',
  PH_END_ORDER_NOTES = 'PH_END_ORDER_NOTES',
  PH_START_ORDER_NOTE = 'PH_START_ORDER_NOTE',
  PH_END_ORDER_NOTE = 'PH_END_ORDER_NOTE',
  PH_ERROR_ORDER_NOTE = 'PH_ERROR_ORDER_NOTE',
  PH_RESET_ORDER_NOTE = 'PH_RESET_ORDER_NOTE',
  PH_START_GET_CART_URL = 'PH_START_GET_CART_URL',
  PH_END_GET_CART_URL = 'PH_END_GET_CART_URL',

  //? purchased history delivery notes...
  PH_FETCH_ORDER_DELIVERY_NOTES = 'PH_FETCH_ORDER_DELIVERY_NOTES',
  PH_FETCH_ORDER_DELIVERY_NOTE = 'PH_FETCH_ORDER_DELIVERY_NOTE',
  PH_CREATE_ORDER_DELIVERY_NOTE = 'PH_CREATE_ORDER_DELIVERY_NOTE',
  PH_UPDATE_ORDER_DELIVERY_NOTE = 'PH_UPDATE_ORDER_DELIVERY_NOTE',
  PH_DELETE_ORDER_DELIVERY_NOTE = 'PH_DELETE_ORDER_DELIVERY_NOTE',
  PH_START_ORDER_DELIVERY_NOTES = 'PH_START_ORDER_DELIVERY_NOTES',
  PH_END_ORDER_DELIVERY_NOTES = 'PH_END_ORDER_DELIVERY_NOTES',
  PH_START_ORDER_DELIVERY_NOTE = 'PH_START_ORDER_DELIVERY_NOTE',
  PH_END_ORDER_DELIVERY_NOTE = 'PH_END_ORDER_DELIVERY_NOTE',
  PH_ERROR_ORDER_DELIVERY_NOTE = 'PH_ERROR_ORDER_DELIVERY_NOTE',
  PH_RESET_ORDER_DELIVERY_NOTE = 'PH_RESET_ORDER_DELIVERY_NOTE',

  //? purchased history histories...
  PH_SEARCH_ORDER_HISTORIES = 'PH_SEARCH_ORDER_HISTORIES',
  PH_FETCH_ORDER_HISTORIES = 'PH_FETCH_ORDER_HISTORIES',
  PH_FETCH_ORDER_HISTORY = 'PH_FETCH_ORDER_HISTORY',
  PH_CREATE_ORDER_HISTORY = 'PH_CREATE_ORDER_HISTORY',
  PH_UPDATE_ORDER_HISTORY = 'PH_UPDATE_ORDER_HISTORY',
  PH_STATE_ORDER_HISTORY = 'PH_STATE_ORDER_HISTORY',
  PH_POSITION_ORDER_HISTORY = 'PH_POSITION_ORDER_HISTORY',
  PH_DELETE_ORDER_HISTORY = 'PH_DELETE_ORDER_HISTORY',
  PH_START_ORDER_HISTORIES = 'PH_START_ORDER_HISTORIES',
  PH_END_ORDER_HISTORIES = 'PH_END_ORDER_HISTORIES',
  PH_START_ORDER_HISTORY = 'PH_START_ORDER_HISTORY',
  PH_END_ORDER_HISTORY = 'PH_END_ORDER_HISTORY',
  PH_ERROR_ORDER_HISTORY = 'PH_ERROR_ORDER_HISTORY',
  PH_RESET_ORDER_HISTORY = 'PH_RESET_ORDER_HISTORY',

  //? purchased history...
  PH_SEARCH_ORDERS = 'PH_SEARCH_ORDERS',
  PH_FETCH_ORDERS = 'PH_FETCH_ORDERS',
  PH_FETCH_ORDER_STATUS = 'PH_FETCH_ORDER_STATUS',
  PH_FETCH_PO_STATUSES = 'PH_FETCH_PO_STATUSES',
  PH_FETCH_ORDER_BRANDS_NOT_SHIPPED = 'PH_FETCH_ORDER_BRANDS_NOT_SHIPPED',
  PH_FETCH_PRINT_ORDERS = 'PH_FETCH_PRINT_ORDERS',
  PH_FETCH_ORDER = 'PH_FETCH_ORDER',
  PH_CREATE_ORDER = 'PH_CREATE_ORDER',
  PH_UPDATE_ORDER = 'PH_UPDATE_ORDER',
  PH_STATE_ORDER = 'PH_STATE_ORDER',
  PH_STATE_ORDERS = 'PH_STATE_ORDERS',
  PH_STATE_PO = 'PH_STATE_PO',
  PH_DELETE_ORDER = 'PH_DELETE_ORDER',
  //* loading...
  PH_START_ORDERS = 'PH_START_ORDERS',
  PH_END_ORDERS = 'PH_END_ORDERS',
  PH_START_ORDER = 'PH_START_ORDER',
  PH_END_ORDER = 'PH_END_ORDER',
  PH_START_ORDER_STATUS = 'PH_START_ORDER_STATUS',
  PH_END_ORDER_STATUS = 'PH_END_ORDER_STATUS',
  PH_START_PO_STATUSES = 'PH_START_PO_STATUSES',
  PH_END_PO_STATUSES = 'PH_END_PO_STATUSES',
  PH_START_ORDER_BRANDS_NOT_SHIPPED = 'PH_START_ORDER_BRANDS_NOT_SHIPPED',
  PH_END_ORDER_BRANDS_NOT_SHIPPED = 'PH_END_ORDER_BRANDS_NOT_SHIPPED',
  PH_START_PRINT_ORDERS = 'PH_START_PRINT_ORDERS',
  PH_END_PRINT_ORDERS = 'PH_END_PRINT_ORDERS',
  PH_START_EXPORT_ORDERS = 'PH_START_EXPORT_ORDERS',
  PH_END_EXPORT_ORDERS = 'PH_END_EXPORT_ORDERS',
  PH_ORDERS = 'PH_ORDERS',
  //* errors...
  PH_ERROR_ORDER = 'PH_ERROR_ORDER',
  PH_RESET_ORDER = 'PH_RESET_ORDER',

  //? order notes...
  FETCH_ORDER_NOTES = 'FETCH_ORDER_NOTES',
  FETCH_ORDER_NOTE = 'FETCH_ORDER_NOTE',
  CREATE_ORDER_NOTE = 'CREATE_ORDER_NOTE',
  UPDATE_ORDER_NOTE = 'UPDATE_ORDER_NOTE',
  STATE_ORDER_NOTE = 'STATE_ORDER_NOTE',
  DELETE_ORDER_NOTE = 'DELETE_ORDER_NOTE',
  START_GET_CART_URL = 'START_GET_CART_URL',
  END_GET_CART_URL = 'END_GET_CART_URL',
  //* loading...
  START_ORDER_NOTES = 'START_ORDER_NOTES',
  END_ORDER_NOTES = 'END_ORDER_NOTES',
  START_ORDER_NOTE = 'START_ORDER_NOTE',
  END_ORDER_NOTE = 'END_ORDER_NOTE',
  //* errors...
  ERROR_ORDER_NOTE = 'ERROR_ORDER_NOTE',
  RESET_ORDER_NOTE = 'RESET_ORDER_NOTE',

  //? order delivery notes...
  FETCH_ORDER_DELIVERY_NOTES = 'FETCH_ORDER_DELIVERY_NOTES',
  FETCH_ORDER_DELIVERY_NOTE = 'FETCH_ORDER_DELIVERY_NOTE',
  CREATE_ORDER_DELIVERY_NOTE = 'CREATE_ORDER_DELIVERY_NOTE',
  UPDATE_ORDER_DELIVERY_NOTE = 'UPDATE_ORDER_DELIVERY_NOTE',
  STATE_ORDER_DELIVERY_NOTE = 'STATE_ORDER_DELIVERY_NOTE',
  DELETE_ORDER_DELIVERY_NOTE = 'DELETE_ORDER_DELIVERY_NOTE',
  //* loading...
  START_ORDER_DELIVERY_NOTES = 'START_ORDER_DELIVERY_NOTES',
  END_ORDER_DELIVERY_NOTES = 'END_ORDER_DELIVERY_NOTES',
  START_ORDER_DELIVERY_NOTE = 'START_ORDER_DELIVERY_NOTE',
  END_ORDER_DELIVERY_NOTE = 'END_ORDER_DELIVERY_NOTE',
  //* errors...
  ERROR_ORDER_DELIVERY_NOTE = 'ERROR_ORDER_DELIVERY_NOTE',
  RESET_ORDER_DELIVERY_NOTE = 'RESET_ORDER_DELIVERY_NOTE',

  //? reports...
  FETCH_ORDERS_REPORT = 'FETCH_ORDERS_REPORT',
  FETCH_COMPLETED_ORDERS_REPORT = 'FETCH_COMPLETED_ORDERS_REPORT',
  FETCH_PROFIT_REPORT = 'FETCH_PROFIT_REPORT',
  FETCH_USERS_REPORT = 'FETCH_USERS_REPORT',
  FETCH_DRIVERS_REPORT = 'FETCH_DRIVERS_REPORT',
  //* loading...
  START_REPORTS = 'START_REPORTS',
  END_REPORTS = 'END_REPORTS',

  //? notifications...
  FETCH_NOTIFICATIONS = 'FETCH_NOTIFICATIONS',
  FETCH_MANAGEMENT_NOTIFICATIONS = 'FETCH_MANAGEMENT_NOTIFICATIONS',
  FETCH_NOTIFICATION = 'FETCH_NOTIFICATION',
  FETCH_MANAGEMENT_NOTIFICATION = 'FETCH_MANAGEMENT_NOTIFICATION',
  CREATE_NOTIFICATION = 'CREATE_NOTIFICATION',
  DELETE_NOTIFICATION = 'DELETE_NOTIFICATION',
  READ_NOTIFICATION = 'READ_NOTIFICATION',
  //* loading...
  START_NOTIFICATIONS = 'START_NOTIFICATIONS',
  END_NOTIFICATIONS = 'END_NOTIFICATIONS',
  START_MANAGEMENT_NOTIFICATIONS = 'START_MANAGEMENT_NOTIFICATIONS',
  END_MANAGEMENT_NOTIFICATIONS = 'END_MANAGEMENT_NOTIFICATIONS',
  //* errors...
  ERROR_NOTIFICATION = 'ERROR_NOTIFICATION',
  RESET_NOTIFICATION = 'RESET_NOTIFICATION',

  //? payment mthod discounts...
  FETCH_PAYMENT_METHOD_DISCOUNTS = 'FETCH_PAYMENT_METHOD_DISCOUNTS',
  FETCH_PAYMENT_METHOD_DISCOUNT = 'FETCH_PAYMENT_METHOD_DISCOUNT',
  CREATE_PAYMENT_METHOD_DISCOUNT = 'CREATE_PAYMENT_METHOD_DISCOUNT',
  UPDATE_PAYMENT_METHOD_DISCOUNT = 'UPDATE_PAYMENT_METHOD_DISCOUNT',
  STATE_PAYMENT_METHOD_DISCOUNT = 'STATE_PAYMENT_METHOD_DISCOUNT',
  DELETE_PAYMENT_METHOD_DISCOUNT = 'DELETE_PAYMENT_METHOD_DISCOUNT',
  //* loading...
  START_PAYMENT_METHOD_DISCOUNTS = 'START_PAYMENT_METHOD_DISCOUNTS',
  END_PAYMENT_METHOD_DISCOUNTS = 'END_PAYMENT_METHOD_DISCOUNTS',
  START_PAYMENT_METHOD_DISCOUNT = 'START_PAYMENT_METHOD_DISCOUNT',
  END_PAYMENT_METHOD_DISCOUNT = 'END_PAYMENT_METHOD_DISCOUNT',
  //* errors...
  ERROR_PAYMENT_METHOD_DISCOUNT = 'ERROR_PAYMENT_METHOD_DISCOUNT',
  RESET_PAYMENT_METHOD_DISCOUNT = 'RESET_PAYMENT_METHOD_DISCOUNT',

  //? promoCodes...
  FETCH_PROMOCODES = 'FETCH_PROMOCODES',
  FETCH_PROMOCODE = 'FETCH_PROMOCODE',
  CREATE_PROMOCODE = 'CREATE_PROMOCODE',
  UPDATE_PROMOCODE = 'UPDATE_PROMOCODE',
  STATE_PROMOCODE = 'STATE_PROMOCODE',
  DELETE_PROMOCODE = 'DELETE_PROMOCODE',
  VALID_PROMO_CODE = 'VALID_PROMO_CODE',
  //* loading...
  START_PROMOCODES = 'START_PROMOCODES',
  END_PROMOCODES = 'END_PROMOCODES',
  START_PROMOCODE = 'START_PROMOCODE',
  END_PROMOCODE = 'END_PROMOCODE',
  //* errors...
  ERROR_PROMOCODE = 'ERROR_PROMOCODE',
  RESET_PROMOCODE = 'RESET_PROMOCODE',

  //? cartOffers...
  FETCH_CART_OFFERS = 'FETCH_CART_OFFERS',
  FETCH_CART_OFFERS_ORDER = 'FETCH_CART_OFFERS_ORDER',
  FETCH_CART_OFFER = 'FETCH_CART_OFFER',
  CREATE_CART_OFFER = 'CREATE_CART_OFFER',
  UPDATE_CART_OFFER = 'UPDATE_CART_OFFER',
  STATE_CART_OFFER = 'STATE_CART_OFFER',
  DELETE_CART_OFFER = 'DELETE_CART_OFFER',
  //* loading...
  START_CART_OFFERS = 'START_CART_OFFERS',
  END_CART_OFFERS = 'END_CART_OFFERS',
  START_CART_OFFER = 'START_CART_OFFER',
  END_CART_OFFER = 'END_CART_OFFER',
  //* errors...
  ERROR_CART_OFFER = 'ERROR_CART_OFFER',
  RESET_CART_OFFER = 'RESET_CART_OFFER',

  //? Scraping items...
  FETCH_SCRAPING_ITEMS = 'FETCH_SCRAPING_ITEMS',
  FETCH_SCRAPING_ITEM = 'FETCH_SCRAPING_ITEM',
  FETCH_SCRAPING_ITEM_ORDER = 'FETCH_SCRAPING_ITEM_ORDER',
  CREATE_SCRAPING_ITEM = 'CREATE_SCRAPING_ITEM',
  UPDATE_SCRAPING_ITEM = 'UPDATE_SCRAPING_ITEM',
  STATE_SCRAPING_ITEM = 'STATE_SCRAPING_ITEM',
  DELETE_SCRAPING_ITEM = 'DELETE_SCRAPING_ITEM',
  SEARCH_SCRAPING_ITEMS = 'SEARCH_SCRAPING_ITEMS',
  //* loading...
  START_SCRAPING_ITEMS = 'START_SCRAPING_ITEMS',
  END_SCRAPING_ITEMS = 'END_SCRAPING_ITEMS',
  START_SCRAPING_ITEM = 'START_SCRAPING_ITEM',
  END_SCRAPING_ITEM = 'END_SCRAPING_ITEM',
  START_SEARCH_SCRAPING_ITEM = 'START_SEARCH_SCRAPING_ITEM',
  END_SEARCH_SCRAPING_ITEM = 'END_SEARCH_SCRAPING_ITEM',
  //* errors...
  ERROR_SCRAPING_ITEM = 'ERROR_SCRAPING_ITEM',
  RESET_SCRAPING_ITEM = 'RESET_SCRAPING_ITEM',

  //? addresses...
  FETCH_ADDRESSES = 'FETCH_ADDRESSES',
  FETCH_ADDRESS = 'FETCH_ADDRESS',
  CREATE_ADDRESS = 'CREATE_ADDRESS',
  ADD_ADDRESS = 'ADD_ADDRESS',
  UPDATE_ADDRESS = 'UPDATE_ADDRESS',
  DELETE_ADDRESS = 'DELETE_ADDRESS',
  //* loading...
  START_ADDRESSES = 'START_ADDRESSES',
  END_ADDRESSES = 'END_ADDRESSES',
  START_ADDRESS = 'START_ADDRESS',
  END_ADDRESS = 'END_ADDRESS',
  //* errors...
  ERROR_ADDRESS = 'ERROR_ADDRESS',
  RESET_ADDRESS = 'RESET_ADDRESS',

  //? categories...
  SEARCH_CATEGORIES = 'SEARCH_CATEGORIES',
  FETCH_CATEGORIES = 'FETCH_CATEGORIES',
  FETCH_CATEGORY = 'FETCH_CATEGORY',
  CREATE_CATEGORY = 'CREATE_CATEGORY',
  UPDATE_CATEGORY = 'UPDATE_CATEGORY',
  POSITION_CATEGORY = 'POSITION_CATEGORY',
  STATE_CATEGORY = 'STATE_CATEGORY',
  DELETE_CATEGORY = 'DELETE_CATEGORY',
  //* loading...
  START_CATEGORIES = 'START_CATEGORIES',
  END_CATEGORIES = 'END_CATEGORIES',
  START_CATEGORY = 'START_CATEGORY',
  END_CATEGORY = 'END_CATEGORY',
  //* errors...
  ERROR_CATEGORY = 'ERROR_CATEGORY',
  RESET_CATEGORY = 'RESET_CATEGORY',

  //* subcategories...
  FETCH_SUBCATEGORIES = 'FETCH_SUBCATEGORIES',
  START_SUBCATEGORIES = 'START_SUBCATEGORIES',
  END_SUBCATEGORIES = 'END_SUBCATEGORIES',
  CLEAR_SUBCATEGORIES = 'CLEAR_SUBCATEGORIES',

  //? groups...
  SEARCH_GROUPS = 'SEARCH_GROUPS',
  FETCH_GROUPS = 'FETCH_GROUPS',
  FETCH_GROUPS_FEE = 'FETCH_GROUPS_FEE',
  FETCH_GROUPS_EXCHANGE = 'FETCH_GROUPS_EXCHANGE',
  FETCH_GROUPS_SHIPPING = 'FETCH_GROUPS_SHIPPING',
  FETCH_GROUPS_FAST_SHIPPING = 'FETCH_GROUPS_FAST_SHIPPING',
  FETCH_GROUPS_INSURANCE = 'FETCH_GROUPS_INSURANCE',
  FETCH_GROUPS_EXCHANGE_REFUND = 'FETCH_GROUPS_EXCHANGE_REFUND',
  FETCH_GROUPS_DELIVERY = 'FETCH_GROUPS_DELIVERY',
  FETCH_GROUPS_TAX = 'FETCH_GROUPS_TAX',
  FETCH_GROUP = 'FETCH_GROUP',
  FETCH_TAX_GROUP = 'FETCH_TAX_GROUP',
  FETCH_INSURANCE_GROUP = 'FETCH_INSURANCE_GROUP',
  FETCH_DELIVERY_GROUP = 'FETCH_DELIVERY_GROUP',
  FETCH_EXCHANGE_GROUP = 'FETCH_EXCHANGE_GROUP',
  CREATE_GROUP = 'CREATE_GROUP',
  UPDATE_GROUP = 'UPDATE_GROUP',
  POSITION_GROUP = 'POSITION_GROUP',
  STATE_GROUP = 'STATE_GROUP',
  DELETE_GROUP = 'DELETE_GROUP',
  //* loading...
  START_GROUPS = 'START_GROUPS',
  END_GROUPS = 'END_GROUPS',
  START_GROUP = 'START_GROUP',
  END_GROUP = 'END_GROUP',
  //* errors...
  ERROR_GROUP = 'ERROR_GROUP',
  RESET_GROUP = 'RESET_GROUP',

  //? transactions...
  FETCH_TRANSACTIONS = 'FETCH_TRANSACTIONS',
  FETCH_ADMIN_TRANSACTIONS = 'FETCH_ADMIN_TRANSACTIONS',
  FETCH_AMOUNT_TRANSACTIONS = 'FETCH_AMOUNT_TRANSACTIONS',
  FETCH_POINTS_TRANSACTIONS = 'FETCH_POINTS_TRANSACTIONS',
  FETCH_USER_TRANSACTIONS = 'FETCH_USER_TRANSACTIONS',
  FETCH_TRANSACTION = 'FETCH_TRANSACTION',
  CLEAR_TRANSACTION = 'CLEAR_TRANSACTION',
  CREATE_TRANSACTION = 'CREATE_TRANSACTION',
  UPDATE_TRANSACTION = 'UPDATE_TRANSACTION',
  STATE_TRANSACTION = 'STATE_TRANSACTION',
  DELETE_TRANSACTION = 'DELETE_TRANSACTION',
  CHECK_TRANSACTION = 'CHECK_TRANSACTION',
  CONFIRM_TRANSACTION = 'CONFIRM_TRANSACTION',
  //* loading...
  START_TRANSACTIONS = 'START_TRANSACTIONS',
  END_TRANSACTIONS = 'END_TRANSACTIONS',
  START_TRANSACTION = 'START_TRANSACTION',
  END_TRANSACTION = 'END_TRANSACTION',

  //? feedbacks...
  FETCH_FEEDBACKS = 'FETCH_FEEDBACKS',
  FETCH_FEEDBACK = 'FETCH_FEEDBACK',
  DELETE_FEEDBACK = 'DELETE_FEEDBACK',
  //* loading...
  START_FEEDBACKS = 'START_FEEDBACKS',
  END_FEEDBACKS = 'END_FEEDBACKS',

  //? settings...
  FETCH_SETTINGS = 'FETCH_SETTINGS',
  UPDATE_SUPPORT = 'UPDATE_SUPPORT',
  //* loading...
  START_SETTINGS = 'START_SETTINGS',
  END_SETTINGS = 'END_SETTINGS',
  START_UPDATE_SUPPORT = 'START_UPDATE_SUPPORT',
  END_UPDATE_SUPPORT = 'END_UPDATE_SUPPORT',
  //* Store...
  FETCH_STORE = 'FETCH_STORE',
  UPDATE_STORE = 'UPDATE_STORE',
  //* loading...
  START_STORE = 'START_STORE',
  END_STORE = 'END_STORE',
  //* errors...
  ERROR_STORE = 'ERROR_STORE',
  RESET_STORE = 'RESET_STORE',
  //* Store Settings...
  FETCH_STORE_SETTINGS = 'FETCH_STORE_SETTINGS',
  UPDATE_STORE_SETTINGS = 'UPDATE_STORE_SETTINGS',
  //* loading...
  START_STORE_SETTINGS = 'START_STORE_SETTINGS',
  END_STORE_SETTINGS = 'END_STORE_SETTINGS',
  //* Security Settings...
  //* loading...
  START_PASSWORD = 'START_PASSWORD',
  END_PASSWORD = 'END_PASSWORD',
  //* Profile Settings...
  //* loading...
  START_PROFILE = 'START_PROFILE',
  END_PROFILE = 'END_PROFILE',
  UPDATE_PROFILE = 'UPDATE_PROFILE',

  //? payment methods...
  FETCH_PAYMENT_METHODS = 'FETCH_PAYMENT_METHODS',
  FETCH_PAYMENT_METHOD = 'FETCH_PAYMENT_METHOD',
  CREATE_PAYMENT_METHOD = 'CREATE_PAYMENT_METHOD',
  UPDATE_PAYMENT_METHOD = 'UPDATE_PAYMENT_METHOD',
  STATE_PAYMENT_METHOD = 'STATE_PAYMENT_METHOD',
  DELETE_PAYMENT_METHOD = 'DELETE_PAYMENT_METHOD',
  //* loading...
  START_PAYMENT_METHODS = 'START_PAYMENT_METHODS',
  END_PAYMENT_METHODS = 'END_PAYMENT_METHODS',
  START_PAYMENT_METHOD = 'START_PAYMENT_METHOD',
  END_PAYMENT_METHOD = 'END_PAYMENT_METHOD',
  //* errors...
  ERROR_PAYMENT_METHOD = 'ERROR_PAYMENT_METHOD',
  RESET_PAYMENT_METHOD = 'RESET_PAYMENT_METHOD',

  //? errors...
  AUTH_ERROR = 'AUTH_ERROR',
  RESET_AUTH_ERROR = 'RESET_AUTH_ERROR',
  ACCOUNT_ERROR = 'ACCOUNT_ERROR',

  //* loading...

  // main loading.
  START_LOADING = 'START_LOADING',
  END_LOADING = 'END_LOADING',

  // main loading.
  START_HOME = 'START_HOME',
  END_HOME = 'END_HOME',

  // search loading.
  START_SEARCH = 'START_SEARCH',
  END_SEARCH = 'END_SEARCH',

  // Errors...
  MAIN_ERROR = 'MAIN_ERROR',

  // customer cart...
  FETCH_CUSTOMER_CART = 'FETCH_CUSTOMER_CART',
  CREATE_CART_ITEM = 'CREATE_CART_ITEM',
  ADD_ITEM_TO_CART = 'ADD_ITEM_TO_CART',
  INCREASE_CART_ITEM_QUANTITY = 'INCREASE_CART_ITEM_QUANTITY',
  DECREASE_CART_ITEM_QUANTITY = 'DECREASE_CART_ITEM_QUANTITY',
  TOGGLE_SELECTED_CART_ITEM = 'TOGGLE_SELECTED_CART_ITEM',
  REMOVE_CART_ITEM = 'REMOVE_CART_ITEM',
  REMOVE_CART_ITEMS = 'REMOVE_CART_ITEMS',
  //* loading...
  START_CUSTOMER_CART = 'START_CUSTOMER_CART',
  END_CUSTOMER_CART = 'END_CUSTOMER_CART',
  //* errors...
  ERROR_CUSTOMER_CART = 'ERROR_CUSTOMER_CART',
  RESET_CUSTOMER_CART = 'RESET_CUSTOMER_CART',

  // customer checkout...
  START_CHECKOUT = 'START_CHECKOUT',
  END_CHECKOUT = 'END_CHECKOUT',
  FETCH_CHECKOUT = 'FETCH_CHECKOUT',
  ERROR_CHECKOUT = 'ERROR_CHECKOUT',

  // Shipments types
  FETCH_SHIPMENTS = 'FETCH_SHIPMENTS',
  FETCH_SHIPMENT = 'FETCH_SHIPMENT',
  CREATE_SHIPMENT = 'CREATE_SHIPMENT',
  UPDATE_SHIPMENT = 'UPDATE_SHIPMENT',
  REMOVE_SHIPMENT = 'REMOVE_SHIPMENT',
  STATE_SHIPMENT = 'STATE_SHIPMENT',
  START_SHIPMENTS = 'START_SHIPMENTS',
  END_SHIPMENTS = 'END_SHIPMENTS',
  START_SHIPMENT = 'START_SHIPMENT',
  END_SHIPMENT = 'END_SHIPMENT',
  ERROR_SHIPMENT = 'ERROR_SHIPMENT',
  RESET_SHIPMENT = 'RESET_SHIPMENT',
  FETCH_SHIPMENT_STATUS = 'FETCH_SHIPMENT_STATUS',
  START_SHIPMENT_STATUS = 'START_SHIPMENT_STATUS',
  END_SHIPMENT_STATUS = 'END_SHIPMENT_STATUS',

  // Warehouse Ops — Receiving
  FETCH_RECEIVING_SHIPMENTS = 'FETCH_RECEIVING_SHIPMENTS',
  FETCH_RECEIVING_SHIPMENT = 'FETCH_RECEIVING_SHIPMENT',
  UPDATE_RECEIVING_SHIPMENT = 'UPDATE_RECEIVING_SHIPMENT',
  START_RECEIVING_SHIPMENTS = 'START_RECEIVING_SHIPMENTS',
  END_RECEIVING_SHIPMENTS = 'END_RECEIVING_SHIPMENTS',
  START_RECEIVING_SHIPMENT = 'START_RECEIVING_SHIPMENT',
  END_RECEIVING_SHIPMENT = 'END_RECEIVING_SHIPMENT',
  START_ADVANCE_SHIPMENT = 'START_ADVANCE_SHIPMENT',
  END_ADVANCE_SHIPMENT = 'END_ADVANCE_SHIPMENT',

  // Warehouse Ops — Sorting
  FETCH_SORTING_PACKAGE = 'FETCH_SORTING_PACKAGE',
  RESET_SORTING_PACKAGE = 'RESET_SORTING_PACKAGE',
  UPDATE_SORTING_PACKAGE = 'UPDATE_SORTING_PACKAGE',
  START_SORTING_PACKAGE = 'START_SORTING_PACKAGE',
  END_SORTING_PACKAGE = 'END_SORTING_PACKAGE',
  START_SORTING_SCAN = 'START_SORTING_SCAN',
  END_SORTING_SCAN = 'END_SORTING_SCAN',

  // Warehouse Ops — Pack by Order
  FETCH_PACKING_ORDER = 'FETCH_PACKING_ORDER',
  RESET_PACKING_ORDER = 'RESET_PACKING_ORDER',
  UPDATE_PACKING_ORDER = 'UPDATE_PACKING_ORDER',
  START_PACKING_ORDER = 'START_PACKING_ORDER',
  END_PACKING_ORDER = 'END_PACKING_ORDER',
  START_PACKING_SCAN = 'START_PACKING_SCAN',
  END_PACKING_SCAN = 'END_PACKING_SCAN',

  //? provinces...
  FETCH_PROVINCES = 'FETCH_PROVINCES',
  FETCH_PROVINCE = 'FETCH_PROVINCE',
  CREATE_PROVINCE = 'CREATE_PROVINCE',
  DELETE_PROVINCE = 'DELETE_PROVINCE',
  UPDATE_PROVINCE = 'UPDATE_PROVINCE',
  TOGGLE_PROVINCE_ACTIVE = 'TOGGLE_PROVINCE_ACTIVE',
  START_PROVINCES = 'START_PROVINCES',
  END_PROVINCES = 'END_PROVINCES',
  START_PROVINCE = 'START_PROVINCE',
  END_PROVINCE = 'END_PROVINCE',
  ERROR_PROVINCE = 'ERROR_PROVINCE',
  RESET_PROVINCE = 'RESET_PROVINCE',

  //? cities (v1)...
  FETCH_CITIES = 'FETCH_CITIES',
  FETCH_CITY = 'FETCH_CITY',
  CREATE_CITY = 'CREATE_CITY',
  DELETE_CITY = 'DELETE_CITY',
  UPDATE_CITY = 'UPDATE_CITY',
  TOGGLE_CITY_ACTIVE = 'TOGGLE_CITY_ACTIVE',
  START_CITIES = 'START_CITIES',
  END_CITIES = 'END_CITIES',
  START_CITY = 'START_CITY',
  END_CITY = 'END_CITY',
  ERROR_CITY = 'ERROR_CITY',
  RESET_CITY = 'RESET_CITY',

  //? governorates...
  FETCH_GOVERNORATES = 'FETCH_GOVERNORATES',
  FETCH_GOVERNORATE = 'FETCH_GOVERNORATE',
  CREATE_GOVERNORATE = 'CREATE_GOVERNORATE',
  DELETE_GOVERNORATE = 'DELETE_GOVERNORATE',
  UPDATE_GOVERNORATE = 'UPDATE_GOVERNORATE',
  TOGGLE_GOVERNORATE_ACTIVE = 'TOGGLE_GOVERNORATE_ACTIVE',
  //* loading...
  START_GOVERNORATES = 'START_GOVERNORATES',
  END_GOVERNORATES = 'END_GOVERNORATES',
  START_GOVERNORATE = 'START_GOVERNORATE',
  END_GOVERNORATE = 'END_GOVERNORATE',
  //* errors...
  ERROR_GOVERNORATE = 'ERROR_GOVERNORATE',
  RESET_GOVERNORATE = 'RESET_GOVERNORATE',

  //? districts...
  FETCH_DISTRICTS = 'FETCH_DISTRICTS',
  START_DISTRICTS = 'START_DISTRICTS',
  END_DISTRICTS = 'END_DISTRICTS',
  ERROR_DISTRICT = 'ERROR_DISTRICT',
  RESET_DISTRICT = 'RESET_DISTRICT',

  FETCH_AREAS = 'FETCH_AREAS',
  FETCH_AREA = 'FETCH_AREA',
  START_AREAS = 'START_AREAS',
  START_AREA = 'START_AREA',
  END_AREAS = 'END_AREAS',
  END_AREA = 'END_AREA',

  RESET_AREAS = 'RESET_AREAS',
  RESET_AREA = 'RESET_AREA',
  CREATE_AREAS = 'CREATE_AREAS',
  UPDATE_AREA = 'UPDATE_AREA',
  TOGGLE_AREA_ACTIVE = 'TOGGLE_AREA_ACTIVE',
  DELETE_AREA = 'DELETE_AREA',

  // errors...
  ERROR_AREA = 'ERROR_AREA',

  FETCH_PRODUCT_TYPES = 'FETCH_PRODUCT_TYPES',
  START_PRODUCT_TYPES = 'START_PRODUCT_TYPES',
  END_PRODUCT_TYPES = 'END_PRODUCT_TYPES',
  CREATE_PRODUCT_TYPE = 'CREATE_PRODUCT_TYPE',
  UPDATE_PRODUCT_TYPES = 'UPDATE_PRODUCT_TYPES',
  DELETE_PRODUCT_TYPES = 'DELETE_PRODUCT_TYPES',
  RESET_PRODUCT_TYPES = 'RESET_PRODUCT_TYPES',

  ERROR_PRODUCT_TYPES = 'ERROR_PRODUCT_TYPES',

  FETCH_USER_STYLES = 'FETCH_USER_STYLES',
  START_USER_STYLES = 'START_USER_STYLES',
  END_USER_STYLES = 'END_USER_STYLES',
  CREATE_USER_STYLE = 'CREATE_USER_STYLE',
  UPDATE_USER_STYLES = 'UPDATE_USER_STYLES',
  DELETE_USER_STYLES = 'DELETE_USER_STYLES',
  RESET_USER_STYLES = 'RESET_USER_STYLES',

  ERROR_USER_STYLES = 'ERROR_USER_STYLES',

  FETCH_GLOBAL_AI_SETTINGS = 'FETCH_GLOBAL_AI_SETTINGS',
  START_GLOBAL_AI_SETTINGS = 'START_GLOBAL_AI_SETTINGS',
  END_GLOBAL_AI_SETTINGS = 'END_GLOBAL_AI_SETTINGS',
  UPDATE_GLOBAL_AI_SETTINGS = 'UPDATE_GLOBAL_AI_SETTINGS',
  RESET_GLOBAL_AI_SETTINGS = 'RESET_GLOBAL_AI_SETTINGS',

  ERROR_GLOBAL_AI_SETTINGS = 'ERROR_GLOBAL_AI_SETTINGS',

  //? screen messages...
  FETCH_SCREEN_MESSAGE = 'FETCH_SCREEN_MESSAGE',
  CREATE_SCREEN_MESSAGE = 'CREATE_SCREEN_MESSAGE',
  UPDATE_SCREEN_MESSAGE = 'UPDATE_SCREEN_MESSAGE',
  START_SCREEN_MESSAGE = 'START_SCREEN_MESSAGE',
  END_SCREEN_MESSAGE = 'END_SCREEN_MESSAGE',
  RESET_SCREEN_MESSAGE = 'RESET_SCREEN_MESSAGE',
  ERROR_SCREEN_MESSAGE = 'ERROR_SCREEN_MESSAGE',
  FETCH_SCREEN_MESSAGES = 'FETCH_SCREEN_MESSAGES',
  START_SCREEN_MESSAGES = 'START_SCREEN_MESSAGES',
  END_SCREEN_MESSAGES = 'END_SCREEN_MESSAGES',
  REMOVE_SCREEN_MESSAGE = 'REMOVE_SCREEN_MESSAGE',
}

export enum RefundActionTypes {
  GET_REFUNDS = 'GET_REFUNDS',
  GET_REFUND = 'GET_REFUND',
  CREATE_REFUND = 'CREATE_REFUND',
  UPDATE_REFUND = 'UPDATE_REFUND',
  REMOVE_REFUND = 'REMOVE_REFUND',
  CHANGE_REFUND_STATE = 'CHANGE_REFUND_STATE',
  LOADING_REFUNDS = 'LOADING_REFUNDS',
  LOADING_REFUND = 'LOADING_REFUND',
  ERROR_REFUNDS = 'ERROR_REFUNDS',
  ERROR_REFUND = 'ERROR_REFUND',
}

export enum RefundRequestActionTypes {
  GET_REFUND_REQUESTS = 'GET_REFUND_REQUESTS',
  GET_REFUND_REQUEST = 'GET_REFUND_REQUEST',
  UPDATE_REFUND_REQUEST = 'UPDATE_REFUND_REQUEST',
  REMOVE_REFUND_REQUEST = 'REMOVE_REFUND_REQUEST',
  CHANGE_REFUND_REQUEST_STATE = 'CHANGE_REFUND_REQUEST_STATE',
  LOADING_REFUND_REQUESTS = 'LOADING_REFUND_REQUESTS',
  LOADING_REFUND_REQUEST = 'LOADING_REFUND_REQUEST',
  ERROR_REFUND_REQUESTS = 'ERROR_REFUND_REQUESTS',
  ERROR_REFUND_REQUEST = 'ERROR_REFUND_REQUEST',
}

export enum LayoutActionTypes {
  LOADING_LAYOUTS = 'LOADING_LAYOUTS',
  GET_LAYOUTS = 'GET_LAYOUTS',
  ERROR_LAYOUTS = 'ERROR_LAYOUTS',
  UPDATE_POSITION_LAYOUT = 'UPDATE_POSITION_LAYOUT',
  LOADING_LAYOUT = 'LOADING_LAYOUT',
  GET_LAYOUT = 'GET_LAYOUT',
  ERROR_LAYOUT = 'ERROR_LAYOUT',
  CHANGE_STATE_LAYOUT = 'CHANGE_STATE_LAYOUT',
  REMOVE_LAYOUT = 'REMOVE_LAYOUT',
  CREATE_LAYOUT = 'CREATE_LAYOUT',
  UPDATE_LAYOUT = 'UPDATE_LAYOUT',
}

export enum WatcherActionTypes {
  FETCH_MESSAGES = 'FETCH_MESSAGES',
  FETCH_MESSAGE = 'FETCH_MESSAGE',
  CREATE_MESSAGE = 'CREATE_MESSAGE',
  UPDATE_MESSAGE = 'UPDATE_MESSAGE',
  DELETE_MESSAGE = 'DELETE_MESSAGE',
  STATE_MESSAGE = 'STATE_MESSAGE',
  LOADING_MESSAGES = 'LOADING_MESSAGES',
  LOADING_MESSAGE = 'LOADING_MESSAGE',
  ERROR_MESSAGES = 'ERROR_MESSAGES',
  ERROR_MESSAGE = 'ERROR_MESSAGE',
  RESET_MESSAGES_ERROR = 'RESET_MESSAGES_ERROR',
  FETCH_AUTOMATIONS = 'FETCH_AUTOMATIONS',
  FETCH_AUTOMATION = 'FETCH_AUTOMATION',
  CREATE_AUTOMATION = 'CREATE_AUTOMATION',
  UPDATE_AUTOMATION = 'UPDATE_AUTOMATION',
  DELETE_AUTOMATION = 'DELETE_AUTOMATION',
  STATE_AUTOMATION = 'STATE_AUTOMATION',
  LOADING_AUTOMATIONS = 'LOADING_AUTOMATIONS',
  LOADING_AUTOMATION = 'LOADING_AUTOMATION',
}

export enum WarehouseActionTypes {
  GET_WAREHOUSES = 'GET_WAREHOUSES',
  GET_WAREHOUSE = 'GET_WAREHOUSE',
  CREATE_WAREHOUSE = 'CREATE_WAREHOUSE',
  UPDATE_WAREHOUSE = 'UPDATE_WAREHOUSE',
  REMOVE_WAREHOUSE = 'REMOVE_WAREHOUSE',
  CHANGE_WAREHOUSE_STATE = 'CHANGE_WAREHOUSE_STATE',
  LOADING_WAREHOUSES = 'LOADING_WAREHOUSES',
  LOADING_WAREHOUSE = 'LOADING_WAREHOUSE',
  ERROR_WAREHOUSES = 'ERROR_WAREHOUSES',
  ERROR_WAREHOUSE = 'ERROR_WAREHOUSE',
  RESET_WAREHOUSE_ERROR = 'RESET_WAREHOUSE_ERROR',
}

export enum GovernorateActionTypes {
  FETCH_GOVERNORATES = 'FETCH_GOVERNORATES',
  FETCH_GOVERNORATE = 'FETCH_GOVERNORATE',
  START_GOVERNORATES = 'START_GOVERNORATES',
  END_GOVERNORATES = 'END_GOVERNORATES',
  START_GOVERNORATE = 'START_GOVERNORATE',
  END_GOVERNORATE = 'END_GOVERNORATE',
  ERROR_GOVERNORATE = 'ERROR_GOVERNORATE',
  RESET_GOVERNORATE = 'RESET_GOVERNORATE',
}

export enum ModelActionTypes {
  ADD_MODEL = 'ADD_MODEL',
  UPDATE_MODEL = 'UPDATE_MODEL',
  REMOVE_MODEL = 'REMOVE_MODEL',
  LOADING_MODEL = 'LOADING_MODEL',
  ERROR_MODEL = 'ERROR_MODEL',
  RESET_MODEL_ERROR = 'RESET_MODEL_ERROR',
  REFRESH_SCRAPING_ITEM = 'REFRESH_SCRAPING_ITEM',
}

export enum OrderStateGroupActionTypes {
  FETCH_ORDER_STATE_GROUPS = 'FETCH_ORDER_STATE_GROUPS',
  FETCH_UNMAPPED_ORDER_STATUSES = 'FETCH_UNMAPPED_ORDER_STATUSES',
  CREATE_ORDER_STATE_GROUP = 'CREATE_ORDER_STATE_GROUP',
  UPDATE_ORDER_STATE_GROUP = 'UPDATE_ORDER_STATE_GROUP',
  DELETE_ORDER_STATE_GROUP = 'DELETE_ORDER_STATE_GROUP',
  ASSIGN_STATUS_TO_GROUP = 'ASSIGN_STATUS_TO_GROUP',
  START_ORDER_STATE_GROUPS = 'START_ORDER_STATE_GROUPS',
  END_ORDER_STATE_GROUPS = 'END_ORDER_STATE_GROUPS',
  ERROR_ORDER_STATE_GROUP = 'ERROR_ORDER_STATE_GROUP',
  RESET_ORDER_STATE_GROUP = 'RESET_ORDER_STATE_GROUP',
}
